<template>
  <section class="qi-panel">
    <p style="display: flex; justify-content: center">
      <span style="font-size: 25px; margin-right: 5px" class="material-icons">
        account_circle
      </span>
      {{ userData.username }}
    </p>

    <div v-if="addSpecialLogin == true">
      <vs-divider />
      <div style="display: flex; align-items: center; margin-top: -18.5px; margin-bottom: -3.5px;">
        <vs-input
          v-model="userSpecial"
          label-placeholder="Usuário"
          @keyup.enter="specialLogin"
        />
        <vs-button
          icon="send"
          color="danger"
          type="flat"
          style="margin-top: 17.5px"
          @click="specialLogin()"
        >
        </vs-button>
      </div>
    </div>
  </section>
</template>

<script>
import LoginService from "../../services/auth";
import { bus } from "../../main";
import {
  saveDataInStorage,
  getLoginDataFromStorage,
  getProfiles,
  logoffUserAndEraseData,
  notifyError,
} from "../../helpers";
export default {
  data() {
    return {
      userData: "",
      addSpecialLogin: false,
      userSpecial: "",
    };
  },
  created() {
    this.userData = getLoginDataFromStorage();

    const profileSpecial = this.userData.profiles.find(
      (element) =>
        element == "DBA" ||
        element == "FinanceiroQI" ||
        element == "AcessoRapidoSM"
    );

    if (profileSpecial) {
      this.addSpecialLogin = true;
    } else {
      this.addSpecialLogin = false;
    }
  },
  methods: {
    specialLogin() {
      this.$vs.loading();
      new LoginService()
        .loginSpecial({
          permission: this.userData.profiles,
          username: this.userSpecial,
        })
        .then((res) => {
          logoffUserAndEraseData();
          this.$acl.change("public");
          location.reload();
          saveDataInStorage(res.data);
          this.changeRules();
          bus.$emit("login");
          this.$router.push("/mailing");
        })
        .catch((error) => {
          const { response } = error;
          this.error = response?.data?.error || "Tente novamente mais tarde.";
          notifyError(this, this.error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    changeRules() {
      const profiles = getProfiles();
      this.$acl.change(profiles);
    },
  },
};
</script>

<style>

</style>
